//Importación de librerias
//---------------SINOJ---------------
//Catalogos
import C002TiposCedula from '../../../src/components/SINOJ/Comun/Catalogos/C002TiposCedula.vue'
import C003Jurisdicciones from '../../../src/components/SINOJ/Comun/Catalogos/C003Jurisdicciones.vue'
import C009TiposPlantilla from '../../../src/components/SINOJ/Comun/Catalogos/C009TiposPlantilla.vue'
import C019Fraccionamientos from '../../../src/components/SINOJ/Comun/Catalogos/C019Fraccionamientos.vue'
import C021Zonas from '../../../src/components/SINOJ/Comun/Catalogos/C021Zonas.vue'
import C007Empresas from '../../../src/components/SINOJ/Comun/Catalogos/C007Empresas.vue'
import C020Notificadores from '../../../src/components/SINOJ/Comun/Catalogos/C020Notificadores.vue'
import C015TiposDeResultado from '../../../src/components/SINOJ/Comun/Catalogos/C015TiposDeResultado.vue'
import C022TiposDeRazones from '../../../src/components/SINOJ/Comun/Catalogos/C022TiposDeRazones.vue'
import C011TiposEstatus from '../../../src/components/SINOJ/Comun/Catalogos/C011TiposEstatus.vue'

//Creamos y asignamos los datos necesarios de SINOJ
const sinoj = [
                { Proviene: 'SINOJ', Nombre: 'C002TiposCedula', datos: C002TiposCedula },
                { Proviene: 'SINOJ', Nombre: 'C003Jurisdicciones', datos: C003Jurisdicciones },
                { Proviene: 'SINOJ', Nombre: 'C009TiposPlantilla', datos: C009TiposPlantilla },
                { Proviene: 'SINOJ', Nombre: 'C019Fraccionamientos', datos: C019Fraccionamientos },
                { Proviene: 'SINOJ', Nombre: 'C021Zonas', datos: C021Zonas },
                { Proviene: 'SINOJ', Nombre: 'C007Empresas', datos: C007Empresas },
                { Proviene: 'SINOJ', Nombre: 'C020Notificadores', datos: C020Notificadores },
                { Proviene: 'SINOJ', Nombre: 'C015TiposDeResultado', datos: C015TiposDeResultado },
                { Proviene: 'SINOJ', Nombre: 'C022TiposDeRazones', datos: C022TiposDeRazones },
                { Proviene: 'SINOJ', Nombre: 'C011TiposEstatus', datos: C011TiposEstatus }
              ]
  
  //Exportamos los datos de SINOJ
  export default sinoj;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/sinoj.js
// module id = null
// module chunks = 